var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 2a5 5 0 1 1-5 5 5 5 0 0 1 5-5M7 .5A6.5 6.5 0 1 0 13.5 7 6.5 6.5 0 0 0 7 .5ZM3 6.3h3.3V2.7h1.4v3.6H11v1.38H7.7v3.62H6.3V7.68H3Z"
})));
export default SvgXor;